import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.css']
})
export class CountdownComponent implements OnInit, OnDestroy {
  @Input() auctionEnd!: number; // timestamp (ms)
  
  countdown: string = '';
  private intervalId: any;

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = this.auctionEnd - now; 
      // const distance =  new Date().getTime() + (1 * 60 * 60 * 1000); 

      if (distance <= 0) {
        clearInterval(this.intervalId);
        // this.countdown = '00d 00h 00m 00s';
          this.countdown = '00h 00m 00s';
        this.onAuctionEnd();
        return;
      }

      // const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.countdown =
        // this.formatTime(days) + 'd ' +
        this.formatTime(hours) + 'h ' +
        this.formatTime(minutes) + 'm ' +
        this.formatTime(seconds) + 's';
    }, 1000);
  }

  formatTime(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  onAuctionEnd() {
    console.log("auction end 🚨");
    // 👉 here you can trigger API or emit event
  }
}
